export default __webpack_public_path__ + "static/media/img18.852f5d66.png";